// @ts-nocheck
import { node } from "~/util/dom";
import { _ } from "~/i18n";
import { analyticsLog } from "~/util/analyticsAction";
import Scene from "~/scene";

const MIN_SIZE = { width: 200, height: 200 };
const MAX_SIZE = { width: 3840, height: 2160 };
const DEFAULT_WIDTH = 800;
const DEFAULT_HEIGHT = 600;
const SIZES = [
	{
		title: _("action.frame.size.0"),
		value: {
			width: 400,
			height: 280,
		},
		selected: true,
	},
	{
		title: _("action.frame.size.1"),
		value: {
			width: 500,
			height: 333,
		},
	},
	{
		title: _("action.frame.size.2"),
		value: {
			width: 700,
			height: 466,
		},
	},
	{
		title: _("action.frame.size.custom"),
		value: {},
	},
];
const MINI_MAPS = [
	{
		title: _("action.frame.previewMap.none"),
		value: 0,
		selected: true,
		logAction: "off",
	},
	{
		title: _("action.frame.previewMap.cr"),
		value: 1,
		logAction: "cz",
	},
	{
		title: _("action.frame.previewMap.world"),
		value: 2,
		logAction: "world",
	},
];
const LABELS = [
	{
		title: _("action.frame.labelSelect.none"),
		value: 0,
		selected: true,
		logAction: "off",
	},
	{
		title: _("action.frame.labelSelect.own"),
		value: 1,
		logAction: "custom",
	},
	{
		title: _("action.frame.labelSelect.all"),
		value: 2,
		logAction: "all",
	},
];

const labelSelect = (val, obj) => val !== undefined && val !== false ? obj.filter(label => label.value === parseInt(val))[0] : null;

export default class MyMapsShareFrame {
	/**
	 *
	 * @param {MyMapsShare} owner Nadřazenýá instance
	 * @param {Object} data Data
	 */
	constructor(owner, data) {
		this._owner = owner;
		this._data = data;
		this._shortFrameURL = "";
		this._lastSize = {};
		this._sizesSelect = null;
		this._miniMapSelect = null;
		this._labelSelect = null;
		this._actualCustomSize = {
			width: DEFAULT_WIDTH,
			height: DEFAULT_HEIGHT,
		};

		this._dom = {
			container: node("div", { className: "frame-tab" }),
			url: node("input", { type: "checkbox" }),
			previewHeader: node("h3", {}, _("action.frame.preview2")),
			inputsContainer: node("div", { className: "inputs" }),
			buttonCopy: node("button", { className: "copy", type: "button" }, _("action.frame.copy")),
			code: node("input", { type: "text" }),
			options: node("div", { className: "options" }),
			previewMap: node("div", { className: "preview-map" }),
			labelSelect: node("div", { className: "options" }),
			licence: node("p", { className: "licence", innerHTML: _("action.frame.licence") }),
			frameContainer: node("div", { className: "frame" }),
			frame: null,
			customSize: {
				widthLabel: node("label", { className: "inputs size" }),
				width: node("input", { type: "number", min: MIN_SIZE.width, max: MAX_SIZE.width, step: 1 }),
				heightLabel: node("label", { className: "inputs size" }),
				height: node("input", { type: "number", min: MIN_SIZE.height, max: MAX_SIZE.height, step: 1 }),
			},
		};

		// logovani pri kopirovani z inputu
		this._dom.code.addEventListener("copy", () => {
			analyticsLog(this._data, {
				type: "copy",
				...this._logData(),
				...this._data.analytics ? this._data.analytics : {},
			}, "iframe");
		});

		this._build();
	}

	destroy() {
		this._sizesSelect.destroy();

		this._dom.buttonCopy.removeEventListener("click", this, false);
		this._dom.customSize.width.removeEventListener("blur", this, false);
		this._dom.customSize.height.removeEventListener("blur", this, false);
	}

	/**
	 * Vrátí kontejner
	 */
	get container() {
		return this._dom.container;
	}

	/**
		 * Nastaví adresu do potřebných políček a vytvoří frame
		 * @param {String} [link=""] URL
		 */
	set link(link = "") {
		this._shortFrameURL = link;
		this._setFrame();
		this._select();
		this._setMaxWidth();
	}

	/**
	 * Zachycení událostí
	 */
	handleEvent(event) {
		const trg = event.target;

		if (event.type === "blur") {
			const width = parseInt(this._dom.customSize.width.value);
			const height = parseInt(this._dom.customSize.height.value);

			if (width < MIN_SIZE.width) {
				this._dom.customSize.width.value = MIN_SIZE.width;
			}

			if (height < MIN_SIZE.height) {
				this._dom.customSize.height.value = MIN_SIZE.height;
			}

			if (width > MAX_SIZE.width) {
				this._dom.customSize.width.value = MAX_SIZE.width;
			}

			if (height > MAX_SIZE.height) {
				this._dom.customSize.height.value = MAX_SIZE.height;
			}

			if (this._actualCustomSize.width === width && this._actualCustomSize.height === height) {
				return;
			}

			this._actualCustomSize.width = width;
			this._actualCustomSize.height = height;

			this._setFrame();
			this._setMaxWidth();
			analyticsLog(this._data, {
				type: "size",
				...this._logData(),
				...this._data.analytics ? this._data.analytics : {},
			}, "iframe");
		} else if (event.type === "click" && trg === this._dom.buttonCopy) {
			this._select();
			analyticsLog(this._data, {
				text: this._dom.buttonCopy.textContent,
				...this._logData(),
				...this._data.analytics ? this._data.analytics : {},
			}, "iframe");
			document.execCommand("copy");
		} else if (event.type === "select-item" && trg === this._sizesSelect.container) {
			this._setFrame();
			this._setMaxWidth();

			analyticsLog(this._data, {
				type: "size",
				...this._logData(),
				...this._data.analytics ? this._data.analytics : {},
			}, "iframe");
		} else if (event.type === "select-item" && trg === this._miniMapSelect.container) {
			const miniMapObject = labelSelect(this._miniMapSelect.value?.value, MINI_MAPS);

			analyticsLog(this._data, {
				type: "preview_map",
				set: miniMapObject ? miniMapObject.logAction : "off",
				...this._data.analytics ? this._data.analytics : {},
			}, "iframe");
			this._owner.setShortFrameLink(false, this._getSelectoptions());
		} else if (event.type === "select-item" && trg === this._labelSelect.container) {
			const labelObject = labelSelect(this._labelSelect?.value?.value, LABELS);

			analyticsLog(this._data, {
				type: "labels",
				set: labelObject ? labelObject.logAction : "off",
				...this._data.analytics ? this._data.analytics : {},
			}, "iframe");
			this._owner.setShortFrameLink(false, this._getSelectoptions());
		} else if (event.type === "open") {
			if (trg === this._sizesSelect.container) {
				this._miniMapSelect.close();
			} else {
				this._sizesSelect.close();
			}
		}
	}

	/**
	 * Nastavení aktivního prvku
	 */
	setActive() {
		if (this._owner.isActive) {
			this._dom.customSize.width.disabled = false;
			this._dom.customSize.height.disabled = false;
		} else {
			this._dom.code.value = "";
			this._dom.customSize.width.disabled = true;
			this._dom.customSize.height.disabled = true;
			this._dom.frameContainer.innerHTML = "";
		}
	}

	/**
	 * Zavře selectbox
	 */
	close() {
		this._sizesSelect.close();
	}

	/**
	 * Zobrazí nebo skryje prvky
	 * @param {Boolean} show
	 */
	showHide(show) {
		if (show) {
			this._dom.container.appendChild(this._dom.inputsContainer);
			this._dom.container.appendChild(this._dom.previewHeader);
			this._dom.container.appendChild(this._dom.options);
			this._dom.container.appendChild(this._dom.frameContainer);
			this._dom.container.appendChild(this._dom.licence);
			if (this._owner.activeTab === "frame") {
				this._setMaxWidth();
			}
		} else {
			this._dom.inputsContainer.remove();
			this._dom.previewHeader.remove();
			this._dom.options.remove();
			this._dom.frameContainer.remove();
			this._dom.licence.remove();
		}
	}

	/**
	 * Sestaví DOM
	 */
	_build() {
		this._dom.inputsContainer.appendChild(this._dom.code);
		this._dom.code.setAttribute("readonly", "");
		this._dom.inputsContainer.appendChild(this._dom.buttonCopy);

		this._dom.buttonCopy.setAttribute("data-log-ignore", "1");

		this._buildSizeOptions();
		if (!Scene.isM3dActive()) {
			this._buildMinimapOptions();
			if (this._data.showLabel) {
				this._buildLabelOptions();
			}
		}

		this._dom.buttonCopy.addEventListener("click", this, false);
		this._dom.customSize.width.addEventListener("blur", this, false);
		this._dom.customSize.height.addEventListener("blur", this, false);

		if (["places-root", "activities-root"].indexOf(this._data.type) === -1) {
			this._dom.container.appendChild(this._dom.options);
			if (!Scene.isM3dActive()) {
				// pro slozky v moje mapy a vlastni body umoznime titulky
				if (this._data.showLabel) {
					this._dom.container.appendChild(this._dom.labelSelect);
				}
				this._dom.container.appendChild(this._dom.previewMap);
			}
			this._dom.container.appendChild(this._dom.inputsContainer);
			this._dom.container.appendChild(this._dom.previewHeader);
			this._dom.container.appendChild(this._dom.frameContainer);
			this._dom.container.appendChild(this._dom.licence);
		}
	}

	_buildSizeOptions() {
		this._sizesSelect = new Mapy.MapsSelect(SIZES);
		this._sizesSelect.container.addEventListener("select-item", this);
		this._sizesSelect.container.addEventListener("open", this);

		const title = node("b", {}, _("action.frame.size"));

		this._dom.options.appendChild(title);
		this._dom.options.appendChild(this._sizesSelect.container);

		const times = node("span");

		times.innerHTML = "&times;";

		const px = node("span");

		px.innerHTML = "px";
		this._dom.customSize.width.value = DEFAULT_WIDTH;
		this._dom.customSize.height.value = DEFAULT_HEIGHT;
		this._dom.customSize.widthLabel.appendChild(this._dom.customSize.width);
		this._dom.customSize.heightLabel.appendChild(times);
		this._dom.customSize.heightLabel.appendChild(this._dom.customSize.height);
		this._dom.customSize.heightLabel.appendChild(px);
	}

	_buildMinimapOptions() {
		this._miniMapSelect = new Mapy.MapsSelect(MINI_MAPS);
		this._miniMapSelect.container.addEventListener("select-item", this);
		this._miniMapSelect.container.addEventListener("open", this);
		const title = node("b", {}, _("action.frame.previewMap"));

		this._dom.previewMap.appendChild(title);
		this._dom.previewMap.appendChild(this._miniMapSelect.container);
	}

	_buildLabelOptions() {
		this._labelSelect = new Mapy.MapsSelect(LABELS);
		this._labelSelect.container.addEventListener("select-item", this);
		this._labelSelect.container.addEventListener("open", this);
		const title = node("b", {}, _("action.frame.labelSelect"));

		this._dom.labelSelect.appendChild(title);
		this._dom.labelSelect.appendChild(this._labelSelect.container);
	}

	/**
	 * Vybere text v políčku s adresou
	 */
	_select() {
		if (this._owner.isActive) {
			this._dom.code.focus();
			this._dom.code.select();
		}
	}

	/**
	 * Nastaví iframe mapy
	 */
	_setFrame() {
		this._dom.frameContainer.innerHTML = "";
		if (this._owner.isActive) {
			this._dom.customSize.width.disabled = false;
			this._dom.customSize.height.disabled = false;

			if (this._sizesSelect.value.value.width) {
				this._dom.customSize.widthLabel.remove();
				this._dom.customSize.heightLabel.remove();
			} else {
				this._dom.options.appendChild(this._dom.customSize.widthLabel);
				this._dom.options.appendChild(this._dom.customSize.heightLabel);
			}
			this._dom.frame = this._getFrame();

			this._dom.frameContainer.innerHTML = "";
			this._dom.frameContainer.appendChild(this._dom.frame);
			this._dom.code.value = this._dom.frame.outerHTML;
		} else {
			this._dom.customSize.width.disabled = true;
			this._dom.customSize.height.disabled = true;
			this._dom.code.value = "";
		}
	}

	/**
	 * Vyrobí iframe
	 * @returns {HTMLIFrameElement}
	 */
	_getFrame() {
		const size = this._getSize();

		return node("iframe", { src: this._shortFrameURL, width: size.width, height: size.height, style: "border:none", frameBorder: "0" });
	}

	/**
	* @typedef {Object} SizeObject
	* @property {number} width - šířka
	* @property {number} height - výška
	*/
	/**
	 * Získá rozměry iframu od uživatele
	 */
	_getSize() {
		let newSize = {};

		if (this._sizesSelect.value.value.width) { //máme to v definovaných rozměrech
			newSize = this._sizesSelect.value.value;
		} else {
			const width = this._actualCustomSize.width;
			const height = this._actualCustomSize.height;
			const re = /^\d{2,}$/u;

			newSize = re.test(width) && re.test(height) ? { width: Math.max(MIN_SIZE.width, width), height: Math.max(MIN_SIZE.height, height) } : { ...this._lastSize };
		}
		Object.assign(this._lastSize, newSize);

		return newSize;
	}

	/**
	 * Nastaví max. šířku pro popup
	 */
	_setMaxWidth() {
		if (!this._owner.isActive) {
			return;
		}

		const div = this._owner.popup.getContainer();
		const mw = this._getSize().width + (div.scrollHeight > div.clientHeight ? 20 : 0);

		this._owner.popup.getContainer().style.maxWidth = `${Math.min(mw, window.innerWidth - 80)}px`;
	}

	_logData() {
		const size = ["small", "medium", "big", "custom"][SIZES.indexOf(this._sizesSelect.value)];
		const labelObject = labelSelect(this._labelSelect?.value?.value, LABELS);
		const miniMapObject = labelSelect(this._miniMapSelect?.value?.value, MINI_MAPS);

		const logData = {
			size,
			labels: labelObject ? labelObject.logAction : "off",
			// eslint-disable-next-line camelcase
			preview_map: miniMapObject ? miniMapObject.logAction : "off",
		};

		if (size === "custom") {
			const dimensions = this._getSize();

			logData.customSize = `${dimensions.width}×${dimensions.height}`;
		}

		return logData;
	}

	_getSelectoptions() {
		const obj = {
			previewMap: this._miniMapSelect.value.value,
		};

		if (this._labelSelect) {
			obj.labels = this._labelSelect.value.value;
		}

		return obj;
	}
}
